module.exports = __webpack_public_path__ + "static/media/app-store.f6d4f026.svg";